module.exports = __webpack_public_path__ + "static/img/2.0694a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shenfree/2.png
// module id = TRKR
// module chunks = 0